import React, { useEffect, useState, useCallback } from "react";

import { useNavigate } from "react-router-dom";
import ClinicPartnerHeader from "../../component/clinicPartnerHeader";
import { Constant } from "../../../../../../helper/constant";
import SalesYearly from "../../../../common_component/salesYearly";
import SalesSummaryYearly from "../../../../common_component/salesSummaryYearly";
import { getInitialDate } from "../../../../../../helper/formatDate";

const ClinicPartnerYearly = () => {
  // =====================
  // Constant Definition
  // =====================

  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [transactionData, setTransactionData] = useState([]);
  const [summaryTransaction, setSummaryTransaction] = useState(null);
  const [filterData, setFilterData] = useState(null);
  const [partnerName, setPartnerName] = useState("");

  // =====================
  // Method Definition
  // =====================

  const onClickSearch = (queryJson, partnerName) => {
    setPartnerName(partnerName);
    setFilterData(queryJson);
  };

  // =====================
  // Network
  // =====================

  const getInitialTransaction = useCallback(async () => {
    try {
      setIsLoading(true);
      let url;
      const params = new URLSearchParams({
        date: filterData.date,
        partner_id: filterData.partner_id || "",
      }).toString();
      url = `${Constant.BASE_API_URL}/tindakan-medis-transaksi/yearly-partner?${params}`;

      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "bearer " + localStorage.getItem("token"),
        },
      });

      if (!response.ok) {
        alert("Gagal Menerima Data");
        if (response.status === 401 || response.status === 403) {
          localStorage.clear();
          return navigate("/login", { replace: true });
        }
      }

      const json = await response.json();
      const data = json.data;

      if (!data.transaction) {
        setTransactionData([]);
      } else {
        setTransactionData(data.transaction);
        setSummaryTransaction(data.summary);
      }
    } catch (error) {
      setTransactionData([]);
      setSummaryTransaction(null);
    } finally {
      setIsLoading(false);
    }
  }, [navigate, filterData]);

  // =====================
  // UseEffect Hook
  // =====================

  useEffect(() => {
    getInitialTransaction();
  }, [filterData, getInitialTransaction]);

  return isLoading ? (
    <div className="loading-container">
      <div className="loader"></div>
      <p>Sedang Memuat Mohon Menunggu</p>
    </div>
  ) : (
    <div>
      <h1>Laporan Klinik Rekanan Tahunan</h1>
      <ClinicPartnerHeader
        typeOfSales={"yearly"}
        onClickSearch={onClickSearch}
      />
      <p>Rekanan yang dicari: {partnerName}</p>
      <SalesYearly
        transactionDate={getInitialDate("yearly")}
        transactionData={transactionData}
      />
      {summaryTransaction ? (
        <SalesSummaryYearly summaryData={summaryTransaction} />
      ) : (
        <p>Loading summary...</p>
      )}
    </div>
  );
};

export default ClinicPartnerYearly;
